export enum LogLevel {
  TRACE = 0,
  DEBUG = 1,
  INFO = 2,
  SUCCESS = 3,
  WARN = 4,
  ERROR = 5,
}

export enum LogMode {
  SILENT = 0,     // Errors only
  MINIMAL = 1,    // System, Console, Chat
  BALANCED = 2,   // Reduced gameplay logs with rate limiting
  GAMEPLAY = 3,   // Combat, stats, items (Useful for checking mechanics)
  NETWORK = 4,    // Network messages (Throttled)
  VERBOSE = 5,    // Everything (Physics, Input, Unthrottled)
  STATS = 6       // Only Stats updates
}

export const LOG_STYLES = {
  TRACE: 'color: #7f8c8d',
  DEBUG: 'color: #3498db',
  INFO: 'color: #ecf0f1',
  SUCCESS: 'color: #2ecc71; font-weight: bold;',
  WARN: 'color: #f1c40f',
  ERROR: 'color: #e74c3c; font-weight: bold;',
  MODE: 'color: #e67e22; font-weight: bold; font-size: 12px;'
};

export interface LogEntry {
  timestamp: string;
  level: LogLevel;
  category: string;
  message: string;
  data?: unknown;
  userAgent?: string;
  url?: string;
}

export type LogListener = (entry: LogEntry) => void;
